﻿export class FileUploadVirusDetected {
    static eventName() { return 'FileUploadVirusDetected'; }
    eventName = FileUploadVirusDetected.eventName;

    constructor(public transferId: string) { }
}